import React, { FC } from 'react';
import { navigationRef } from '@helpers';
import SelectNCFileTypeButton from '@components/operatorPanel/components/elements/buttons/SelectNCFileTypeButton';
import LinkToJobButton from '@components/operatorPanel/components/elements/buttons/LinkToJobButton';
import { HomePageBottomPartProps } from '@components/operatorPanel/components/HomePage/HomePageBottomPart';

export interface HomePageBottomPartButtonsProps
  extends Pick<HomePageBottomPartProps, 'CC' | 'scale' | 'font' | 'autoOpenNCFileModal' | 'systemPopup' | 'shouldHidePopupParam'> {
  shouldDisplaySelectNCFileType: boolean;
  shouldDisplayLinkToJobButton: boolean;
  onModifyNCFileTypePress: (onActionStart: () => void) => void;
  onLinkToJobPress: (onActionStart: () => void) => void;
}

const HomePageBottomPartButtons: FC<HomePageBottomPartButtonsProps> = ({
  shouldDisplaySelectNCFileType,
  shouldDisplayLinkToJobButton,
  onModifyNCFileTypePress,
  onLinkToJobPress,
  CC,
  scale,
  font,
  autoOpenNCFileModal = false,
  systemPopup,
  shouldHidePopupParam,
}) => {
  if (shouldDisplaySelectNCFileType) {
    const isOPPanelScreen = navigationRef.current?.getCurrentRoute()?.name === 'OperatorPanel';
    const autoTrigger = isOPPanelScreen && autoOpenNCFileModal && !!systemPopup && !shouldHidePopupParam;

    return (
      <SelectNCFileTypeButton
        onPress={onModifyNCFileTypePress}
        CC={CC}
        scale={scale}
        font={font}
        autoTrigger={autoTrigger}
      />
    );
  }

  if (shouldDisplayLinkToJobButton) {
    return <LinkToJobButton onPress={onLinkToJobPress} CC={CC} scale={scale} font={font} />;
  }

  return null;
};

export default HomePageBottomPartButtons;
